import { Component } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthStateService} from "../../../core/states/auth-state.service";
import {FormLabelDirective} from "../../../core/directives/form-label.directive";
import {FormInputTextDirective} from "../../../core/directives/form-input-text.directive";
import { AuthService } from '../../../services/auth.service';
import {GlobalConfig, ToastrService} from "ngx-toastr";
import {AlertToast} from "../../../shared/notifications/alert.toast";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    FormsModule,
    FormLabelDirective,
    FormInputTextDirective
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent {
  email: string;
  password: string = "";
  password_confirmation: string = "";
  token: string;
  message: string = "";
  loading = false;
  options: GlobalConfig;
  successMessage: string| null = null;

  constructor(private route: ActivatedRoute,
              private authStateService: AuthStateService,
              private router: Router,
              private authService: AuthService,
              private toastr: ToastrService,
              private spinner: NgxSpinnerService,
            ) {
    this.token = this.route.snapshot.params['token'];
    this.email = this.route.snapshot.params['email'];
    this.options = this.toastr.toastrConfig;
  }

  formatErrors(errors: { [key: string]: string[] }): string {
    if (!errors || typeof errors !== 'object') {
      return '<ul class="list-disc"><li>Ocurrió un error desconocido.</li></ul>';
    }
  
    // Iterar a través de las claves (campos) y los mensajes de error
    let formattedErrors = '<ul class="list-disc">';
    for (const field in errors) {
      if (errors.hasOwnProperty(field)) {
        // Combinar los errores de cada campo en una lista
        errors[field].forEach(errorMessage => {
          formattedErrors += `<li>${errorMessage}</li>`;
        });
      }
    }
    formattedErrors += '</ul>';
  
    return formattedErrors;
  }
  

  resetPassword() {
    const data = {
      email: this.email,
      password: this.password,
      password_confirmation: this.password_confirmation,
      token: this.token
    };
    this.loadingFunc(true);
    this.authService.resetPassword(data).subscribe({
      next: result => {
        this.successMessage = 'Contraseña restablecida con éxito.';
        this.resetPasswordSuccessToast('Contraseña restablecida', this.successMessage);
      },
      error: error => {
        this.resetPasswordErrorToast('Error', this.formatErrors(error.error.errors));
        this.loadingFunc(false);
      },
      complete: () => {
        this.loadingFunc(false);
        this.authService.signIn(this.email, this.password).subscribe({
          next: (value) => {
            if (value.data) {
              this.authStateService.setUser(value.data);
              this.router.navigate(['/dashboard'])
            }
          }
        })
      }
    })
  }

  loadingFunc(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show() : this.spinner.hide();
  }

  resetPasswordErrorToast(title: string, message: string) {
    const opt: any = this.options;
    opt.toastComponent = AlertToast;
    opt.progressBar = true;
    this.options.enableHtml = true;
    opt.type = 'error';
    opt.toastClass = 'toast';
    this.toastr.show(message, title, opt);
  }

  resetPasswordSuccessToast(title: string, message: string) {
    const opt: any = this.options;
    opt.toastComponent = AlertToast;
    opt.progressBar = true;
    opt.type = 'success';
    opt.toastClass = 'toast';
    this.toastr.show(message, title, opt);
  }
}
